import { createActionConst } from '../../../utils/action.utils';

const COMPANY_CONTEXT_NAMESPACE = 'COMPANY_CONTEXT';

export const STORE_COMPANY_CONTEXT = createActionConst(COMPANY_CONTEXT_NAMESPACE, 'STORE_COMPANY_CONTEXT');
export const CLEAR_COMPANY_CONTEXT = createActionConst(COMPANY_CONTEXT_NAMESPACE, 'CLEAR_COMPANY_CONTEXT');
